<template>
<div class="content-i">

    <div class="content-box">
        <div class="element-wrapper">
            <!-- <div class="element-actions d-none d-sm-block">
                <a class="btn btn-primary btn-sm" v-if="is_active_product == 0" @click="addSession">
                    <i class="os-icon os-icon-ui-22"></i>
                    <span >Add Session</span>
                </a>
            </div> -->
            <h6 class="element-header">
                ProductDesk
            </h6>
            <div class="element-box">
                <div class="table-responsive">
                    <table class="table table-striped table-lightborder">
                        <thead>
                            <tr>
                                <th>Product ID</th>
                                <th>Thumbnail</th>
                                <th>SKU</th>
                                <th>Type</th>
                                <th>Last Contributor</th>
                                <th>Last Session</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in products" :key="product.id_product">
                                <td class="nowrap">
                                    {{product.id_product}}
                                </td>
                                <td >
                                    <img class="preview" :src="product.preview" width="60px" height="60px" alt="">
                                </td>
                                <td class="nowrap">{{product.item_identifier}}</td>
                                <td class="nowrap">{{product.category_name}}</td>
                                <td class="nowrap">{{product.last_user}}</td>
                                <td class="nowrap">{{product.id_photodesk_session}}</td>
                                <td>
                                    <router-link tag="a" :to="`/photodesk/products/${product.id_photodesk_product}`">
                                        View
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getProducts()" :offset="5" ></Pagination>
        </div>

    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  name: 'product-list',
  mixins: [CommonFunctions],
  components: { Pagination },
  data () {
    return {
      products: [],
      is_active_product: 0,
      pagination: {
        'current_page': 1
      },
      statusFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Open', 'key': '1' },
        { 'name': 'Closed', 'key': '0' },
        { 'name': 'Cancelled', 'key': '3' }
      ]
    }
  },
  mounted: function () {
    this.getProducts()
  },
  methods: {
    getProducts: function () {
      var self = this
      const url = '/productdesk/products?page=' + this.pagination.current_page
      self.$store.dispatch('updateLoading', 'true')
      this.$http.get(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.products = response.data.data
          self.pagination = response.data
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    }
  }
}
</script>

<style scoped>
    .preview{
            border: 1px solid #e4e9f0;
    }
    .open {
        color:#75da62 !important;
    }
    .closed {
        color: #23b7e5!important;
    }
    .cancelled {
        color: #ddd;
    }
</style>
